import React, { useState } from 'react'
import { BsArrow90DegDown } from 'react-icons/bs'
import expand_caldera from '../../images/expand_caldera.png'

export function DescMobileItem({ item, handleClick }) {
    const { isDesVisible } = item;
    console.log({ isDesVisible, item: item });

    return (
        <div className="item__service--item" onClick={() => handleClick(item.index)}>
            <div className="service--item_header">
                <div className="item_header-title">
                    <h1>{item.index}</h1>
                    <h3>{item.title}</h3>
                </div>
                <div className="item_header-arrow">
                    {isDesVisible ? (<BsArrow90DegDown />) : (<img src={expand_caldera} alt="Expand" />)}

                </div>
            </div>
            {isDesVisible && (
                <div className="service--item_description">
                    <p>{item.desc}</p>
                </div>
            )}
        </div>

    )
}
